var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.place
        ? _c(
            "div",
            [
              _c("page-title-area", [
                _c("h1", [_vm._v(_vm._s(_vm.place.name))]),
              ]),
              _vm._v(" "),
              _c("event-period-selector", {
                attrs: {
                  loading: _vm.loading,
                  "initial-value": _vm.initialEventPeriod,
                },
                on: { submit: _vm.loadEvents, clear: _vm.clearEvents },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center mt-4" },
                [
                  _vm.featureIsActive("s_type_crawling_pests")
                    ? _c("locomotion-filter", {
                        model: {
                          value: _vm.locomotionFilter,
                          callback: function ($$v) {
                            _vm.locomotionFilter = $$v
                          },
                          expression: "locomotionFilter",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("picked-event-chart-button", {
                    attrs: {
                      events: _vm.sortedSelectedEvents,
                      disabled: _vm.hasCrawlingInSelected,
                      "locomotion-scope": _vm.chartLocomotionScope,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }),
                  _vm._v(" "),
                  _vm.featureIsActive("s_type_scanner_upload")
                    ? [
                        _c(
                          "round-button",
                          {
                            attrs: {
                              icon: "camera_alt",
                              "data-testid": "open_scanner_upload",
                            },
                            on: { click: _vm.openScannerUpload },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("scanner_upload.button")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "", disabled: !_vm.isMergeDisabled },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "div",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "d-inline-block",
                                        attrs: {
                                          "data-testid":
                                            "merge-type-tooltip-activator",
                                        },
                                      },
                                      "div",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "round-button",
                                      {
                                        attrs: {
                                          icon: "merge_type",
                                          disabled: _vm.isMergeDisabled,
                                          "data-testid": "merge-type-button",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.mergeDialogVisible = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("merge.button")) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1851107194
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.mergeTooltipText))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }),
                  _vm._v(" "),
                  _c("export-excel-button", {
                    attrs: {
                      events: _vm.sortedSelectedEvents,
                      disabled:
                        !_vm.featureIsActive("s_type_crawling_pests") &&
                        _vm.hasCrawlingInSelected,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }),
                  _vm._v(" "),
                  _c("export-csv-button", {
                    attrs: {
                      events: _vm.sortedSelectedEvents,
                      place: _vm.place.name,
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("station-place-event-table", {
                ref: "table",
                attrs: { events: _vm.filteredEvents, loading: _vm.loading },
                on: {
                  sortedSelectedEventsUpdated: _vm.updateSortedSelectedEvents,
                  editEvent: _vm.editEvent,
                  viewEvents: _vm.viewEvents,
                  eventUpdated: _vm.onEventUpdate,
                },
              }),
              _vm._v(" "),
              _c("station-event-editor", {
                attrs: {
                  place: _vm.place,
                  places: _vm.places,
                  event: _vm.currentEditingEvent,
                },
                on: { update: _vm.onEventUpdate },
                model: {
                  value: _vm.editDialogVisible,
                  callback: function ($$v) {
                    _vm.editDialogVisible = $$v
                  },
                  expression: "editDialogVisible",
                },
              }),
              _vm._v(" "),
              _vm.currentDisplayedEvent
                ? _c("station-event-detail-view", {
                    attrs: {
                      event: _vm.currentDisplayedEvent,
                      hasPrevEvent:
                        _vm.previousEvent && !_vm.previousEvent.processing,
                      hasNextEvent: _vm.nextEvent && !_vm.nextEvent.processing,
                    },
                    on: {
                      previous: function ($event) {
                        return _vm.changeDisplayedIndexBy(-1)
                      },
                      next: function ($event) {
                        return _vm.changeDisplayedIndexBy(1)
                      },
                      pollEvent: function (patch) {
                        return _vm.setEventUpdating(
                          _vm.currentDisplayedEvent,
                          patch
                        )
                      },
                      deleteEvent: _vm.showDeleteConfirmation,
                    },
                    model: {
                      value: _vm.detailViewVisible,
                      callback: function ($$v) {
                        _vm.detailViewVisible = $$v
                      },
                      expression: "detailViewVisible",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("confirm-dialog", {
                attrs: { message: _vm.$t("msg.delete_confirm") },
                on: { yes: _vm.deleteEvent },
                model: {
                  value: _vm.deleteDialogVisible,
                  callback: function ($$v) {
                    _vm.deleteDialogVisible = $$v
                  },
                  expression: "deleteDialogVisible",
                },
              }),
              _vm._v(" "),
              _c("merge-events-dialog", {
                attrs: { "selected-events": _vm.sortedSelectedEvents },
                on: { merged: _vm.onEventsMerged },
                model: {
                  value: _vm.mergeDialogVisible,
                  callback: function ($$v) {
                    _vm.mergeDialogVisible = $$v
                  },
                  expression: "mergeDialogVisible",
                },
              }),
              _vm._v(" "),
              _c("scanner-upload-dialog", {
                ref: "scannerUploadDialog",
                attrs: { place: _vm.place },
                on: { uploaded: _vm.onScannerUpload },
                model: {
                  value: _vm.scannerUploadDialogVisible,
                  callback: function ($$v) {
                    _vm.scannerUploadDialogVisible = $$v
                  },
                  expression: "scannerUploadDialogVisible",
                },
              }),
              _vm._v(" "),
              _c("ai-chat-widget", {
                attrs: {
                  place_id: _vm.place.id,
                  events: _vm.sortedSelectedEvents,
                  disabled: _vm.hasCrawlingInSelected,
                },
              }),
            ],
            1
          )
        : _c("page-load-spinner"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }